<wvre-list-wrapper #animationRoot [ngSwitch]="true">
  <ul *ngSwitchCase="listType === 'unordered'" list-items>
    <ng-container *ngTemplateOutlet="selection"></ng-container>
  </ul>

  <ul *ngSwitchCase="listType === 'unstyled'" class="list-unstyled" list-items>
    <ng-container *ngTemplateOutlet="selection"></ng-container>
  </ul>

  <ol *ngSwitchCase="listType === 'ordered'" list-items>
    <ng-container *ngTemplateOutlet="selection"></ng-container>
  </ol>

  <dl *ngSwitchCase="listType === 'described'" list-items>
    <ng-container *ngTemplateOutlet="selection"></ng-container>
  </dl>

  <ul *ngSwitchCase="listType === 'group-ul' || listType === 'group'" class="list-group" list-items>
    <ng-container *ngTemplateOutlet="selection"></ng-container>
  </ul>

  <div *ngSwitchCase="listType === 'group-div'" class="list-group" list-items>
    <ng-container *ngTemplateOutlet="selection"></ng-container>
  </div>

  <ul *ngSwitchCase="listType === 'group-flush'" class="list-group list-group-flush" list-items>
    <ng-container *ngTemplateOutlet="selection"></ng-container>
  </ul>

  <div *ngSwitchCase="listType === 'group-custom-content'" class="list-group" list-items>
    <ng-container *ngTemplateOutlet="selection"></ng-container>
  </div>

  <div *ngSwitchDefault></div>

</wvre-list-wrapper>

<ng-template #selection>
  <ng-content select="template[list-items]"></ng-content>
</ng-template>
